import styled from 'styled-components';
import IMAGES from 'assets/images';
import { ImUser } from 'react-icons/im';
import { Palette } from 'core/config';

export const Container = styled.div`
    position: absolute;
    width : 95%;
    height : 116px;
    display : flex;
    justify-content : space-between;
    z-index: 100000000000;
`;

export const LogoContainer = styled.div`
    margin-left: 35px;
    padding-top: 48px;
    flex-grow: 1;

    @media only screen and (max-width: 600px) {
        padding-top: 30px;
    }
`;

export const Logo = styled.div`
    background-image : url(${IMAGES.manzilLogo});
    background-size : cover;
    width : 116px;
    height : 18px;
    cursor : pointer;

    @media only screen and (max-width: 600px) {
        background-image: url(${IMAGES.mLogo});
        width: 40px;
        height: 30px;
    }
`;

export const UserNav = styled.div`
    display : flex;
    float: right;
`;

export const ButtonContainer = styled.div`
    padding-top: 40px;
    margin-right: 35px;

    @media only screen and (max-width: 600px) {
        padding-top: 30px;
        margin-right: 30px;
    }
`;

export const Button = styled.div`
    background-color: ${Palette.ORANGE};
    width: 125px;
    height: 33px;
    border-radius: 7px;
    cursor: pointer;
    color: ${Palette.EGGSHELL_WHITE};
    font: normal normal normal 10px/15px 'SofiaPro-Regular';
    text-align: center;
    line-height: 33px;
    text-transform: uppercase;

    @media only screen and (max-width: 600px) {
        width: 93px;
        height: 28px;
        line-height: 28px;
    }
`;

export const ProfileButton = styled.button`
    margin-top: 37.5px;
    margin-right: 1rem;
    height: 2.5rem;
    width: 10rem;
    border-radius: 0.5rem;
    border: 2px solid ${Palette.ORANGE};
    background-color: transparent;
    color: ${Palette.ORANGE};
    font-family: SofiaPro-Regular;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    @media only screen and (max-width: 600px) {
        margin-top: 28.5px;
        height: 2rem;
        width: 8rem;
    }
`;

export const UserIcon = styled(ImUser)`
    margin-right: 5px;
`;
